document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.quick-view-button').forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      const productHandle = this.getAttribute('data-product-handle');
      
      // Show loading state
      document.getElementById('quick-view-container').innerHTML = '<div class="quick-view-loading" style="text-align:center;">Loading...</div>';
      document.getElementById('quick-view-modal').style.display = 'block';
      
      // Fetch only the product content
      fetch(`/products/${productHandle}?quick-view`)
        .then(response => response.text())
        .then(data => {
          const tempDocument = new DOMParser().parseFromString(data, "text/html");
          const productElement = tempDocument.querySelector("#shopify-section-main-product");
      
          const container = document.getElementById("quick-view-container");
          
          container.innerHTML = ''; // Clear loading
          container.appendChild(productElement.cloneNode(true)); // ⬅ Preserve full DOM, Alpine compatible
      
          Alpine.initTree(container);

          container.querySelectorAll('.splide').forEach(el => {
            new Splide(el, {
              perPage: 5,
              focus: 'center',         // 선택된 썸네일을 중앙으로 자동 이동
              isNavigation: true,
              direction: 'ttb',        // 세로 슬라이더일 경우
              pagination: false,
              arrows: false,
              height: 'auto', 
            }).mount();
          });

          
          container.querySelectorAll('.push-btn').forEach(function(button) {
          button.addEventListener('click', function () {
              const direction = button.getAttribute('data-direction');
              const container = document.getElementById("quick-view-container");
              const thumbnailList = container.querySelectorAll(".product-thumbnail-list-item");
              
              const current = container.querySelector(".product-thumbnail-list-item--active");
              if (!current) return;
              
              
              let currentIndex = Array.from(thumbnailList).indexOf(current);
              
              
              let newIndex = direction === "prev" ? currentIndex - 1 : currentIndex + 1;
              if (newIndex < 0 || newIndex >= thumbnailList.length) return;
              
              const newThumbnail = thumbnailList[newIndex];
              if (!newThumbnail) return;
              
              
              const target = newThumbnail.querySelector(".media-thumbnail");
              if (!target || !container.contains(target)) return;
              
              
              if (target.tagName.toLowerCase() === 'a') {
                target.addEventListener('click', e => e.preventDefault());
              }
              
              
              const event = new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window
              });
              target.dispatchEvent(event);
          
              
            });
          });


          if (typeof Shopify !== "undefined" && window.ProductPage) {
            ProductPage.init();
          }
        })
        .catch(error => {
          console.error('Quick view error:', error);
          document.getElementById('quick-view-container').innerHTML = `
            <div class="quick-view-error">
              Error loading product. <button onclick="location.reload()">Try again</button>
            </div>`;
        });
    });
  });
  
  // Close modal
  document.querySelector('.close-quick-view').addEventListener('click', function() {
    document.getElementById('quick-view-modal').style.display = 'none';
  });
  document.querySelector('.shopify-product-form').addEventListener('click', function() {
    document.getElementById('quick-view-modal').style.display = 'none';
    console.log('111');
  });

  // Close when clicking outside
  window.addEventListener('click', function(event) {
    if (event.target === document.getElementById('quick-view-modal')) {
      document.getElementById('quick-view-modal').style.display = 'none';
    }
  });
});
